class TrustCommander {
  constructor() {
    window.caReady = window.caReady || [];
    window.cact = function () { window.caReady.push(arguments); };

    this.ID = '6';
  }

  bindUI() {
    this.UI = {
      videos: document.querySelectorAll('[data-tc-video]'),
    }
  }

  bindEvents() {
    window.cact('consent.get', (result) => {
      const accepted = result.consent.categories[this.ID].status === 'on';

      if (accepted) {
        this.removeOverlay();
      }
    });

    window.cact('consent.onUpdate', (result) => {
      const accepted = result.consent.categories[this.ID].status === 'on';

      if (accepted) {
        this.removeOverlay();
      }
    });

    this.UI.videos.forEach((video) => {
      const button = video.querySelector('button');

      button.addEventListener('click', () => {
        window.cact('consent.update', {
          categories: {
            [this.ID]: { status: 'on' },
          },
        });
      })
    });
  }

  removeOverlay() {
    this.UI.videos.forEach((video) => {
      video.parentNode.removeChild(video);
    });
  }

  init() {
    this.bindUI();
    this.bindEvents();
  }
}

export default TrustCommander;



// WEBPACK FOOTER //
// ./scripts/components/TrustCommander.js